export const COLOR_PALETTE = {
    primary: "#000000",
    secondary: "#ffffff",
    accent: "#ffffff",
    text: "rgba(255, 255, 255, 0.9)",
    textMuted: "rgba(255, 255, 255, 0.5)",
    glow: "rgba(255, 255, 255, 0.2)",
}
